// src/ui/drag-drop.ts

export function attachDragDrop(target: HTMLElement, onFile: (f: File) => void) {
  target.addEventListener('dragover', e => { e.preventDefault(); });
  target.addEventListener('drop', e => {
    e.preventDefault();
    const file = e.dataTransfer?.files?.[0];
    if (file) onFile(file);
  });
}

export function openFile(accept: string): Promise<File | null> {
  return new Promise(resolve => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.style.display = 'none';
    document.body.append(input);
    input.addEventListener('change', () => {
      const f = input.files?.[0] ?? null;
      input.remove();
      resolve(f);
    });
    input.click();
  });
}
